import config from "../../config.json";

const BASE_AUTH_API = config.BASE_AUTH_API;

// List fetches used to return [] on failure, which looked exactly like
// "no notifications". Throw instead so callers can show an error state.
const readListOrThrow = async (res, key) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    throw new Error(data.message || `Request failed with status ${res.status}`);
  }
  return data[key] || [];
};

const getHeaders = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export const fetchNotificationRestaurantsAPI = async (token, ids) => {
  const params = new URLSearchParams();
  ids.forEach((id) => params.append("id", id));
  const url = `${BASE_AUTH_API}notification/restaurants?${params.toString()}`;

  const res = await fetch(url, {
    headers: getHeaders(token),
  });
  return readListOrThrow(res, "restaurants");
};

export const fetchNotificationTemplatesAPI = async (token) => {
  const res = await fetch(`${BASE_AUTH_API}notification-template`, {
    headers: getHeaders(token),
  });
  return readListOrThrow(res, "templates");
};

export const createNotificationTemplateAPI = async (token, payload) => {
  const res = await fetch(`${BASE_AUTH_API}notification-template`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateNotificationTemplateAPI = async (token, id, payload) => {
  const res = await fetch(`${BASE_AUTH_API}notification-template/${id}`, {
    method: "PATCH",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const deleteNotificationTemplateAPI = async (token, id) => {
  const res = await fetch(`${BASE_AUTH_API}notification-template/${id}`, {
    method: "DELETE",
    headers: getHeaders(token),
  });
  return res.json();
};

export const fetchNotificationsAPI = async (
  token,
  ids,
  branchNames,
  filters = {},
) => {
  const params = new URLSearchParams();

  if (ids) ids.forEach((id) => params.append("ids", id));
  if (branchNames)
    branchNames.forEach((branchName) =>
      params.append("branchNames", branchName),
    );
  if (filters.ownerId) params.append("ownerId", filters.ownerId);
  if (filters.branchId) params.append("branchId", filters.branchId);
  if (filters.category && filters.category !== "all") {
    params.append("category", filters.category);
  }
  if (filters.status && filters.status !== "all") {
    params.append("status", filters.status);
  }

  const query = params.toString();
  const res = await fetch(
    `${BASE_AUTH_API}notification${query ? `?${query}` : ""}`,
    {
      headers: getHeaders(token),
    },
  );

  return readListOrThrow(res, "notifications");
};

export const sendNotificationAPI = async (token, payload) => {
  const res = await fetch(`${BASE_AUTH_API}notification/send`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const markNotificationReadAPI = async (token, id) => {
  const res = await fetch(`${BASE_AUTH_API}notification/read/${id}`, {
    method: "PATCH",
    headers: getHeaders(token),
  });
  return res.json();
};

